import { Link } from "react-router-dom";
import { useState } from "react";
import { settingsListName } from "src/api/config";
import Loading from "src/components/Loading";
import { MobileConfigureIcon } from "src/components/ui-icons/menu";

import { useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";
import { selectCurrentUser } from "src/modules/users/selector";

import { FlexCol } from "src/utils/flexLayouts";
import ChangeResponsible from "src/modules/changeResponsible";

export default function SettingsPage() {
  const settings = useAppSelector(state => selectItems(state, settingsListName));
  const currentUser = useAppSelector(selectCurrentUser);
  const [isChangeResponsibleOpen, setIsChangeResponsibleOpen] = useState(false);

  const linkOrButtonClasses =
    "flex px-5 py-[18px] gap-3 items-start rounded-lg border border-gray-300 bg-white";

  if (!settings.length) {
    return <Loading />;
  }

  const userGroupIds = currentUser.groups.map((g: { Id: number }) => g.Id);
  const filteredSettings = settings.filter((setting) =>
    setting.UsersGroup
      ? setting.UsersGroup.some((obj: any) => userGroupIds.includes(obj.ID))
      : false,
  );

  return (
    <div>
      <div className="px-7.5 py-[26px] border-b border-[#DFE4EA]-500">
        <div className="flex items-center gap-2 hover:cursor-pointer w-fit">
          <span>
            <MobileConfigureIcon />
          </span>
          <span>Настройки</span>
        </div>
      </div>
      <div className="p-7.5">
        <div className="p-7.5 pt-5 bg-white rounded-md shadow-custom">
          <h3 className="mb-7.5 font-medium text-black">Мои Документы</h3>
          <FlexCol className="gap-[10px]">
            {filteredSettings.map(setting => {
              if (setting.Title === "Изменение ответственного за пересмотр") {
                return (
                  <button
                    className={linkOrButtonClasses}
                    key={setting.ID}
                    type="button"
                    onClick={() => setIsChangeResponsibleOpen(true)}
                  >
                    <img src={setting.IconUrl} alt="settingIcon" />
                    {setting.Title}
                  </button>
                );
              }

              return (
                <>
                  {(setting.ID === 7 && (
                    <Link
                      key={setting.ID}
                      title={setting.Description}
                      rel="noreferrer"
                      className={linkOrButtonClasses}
                      to={"/dashboard/1/change-approvers"}
                    >
                      <img src={setting.IconUrl} alt="settingIcon" />
                      {setting.Title}
                    </Link>
                  )) || (
                    <a
                      className={linkOrButtonClasses}
                      target="_blank"
                      href={setting.Path}
                      key={setting.ID}
                      title={setting.Description}
                      rel="noreferrer"
                    >
                      <img src={setting.IconUrl} alt="settingIcon" />
                      {setting.Title}
                    </a>
                  )}
                </>
              );
            })}
          </FlexCol>
          <ChangeResponsible
            open={isChangeResponsibleOpen}
            onClose={() => setIsChangeResponsibleOpen(false)}
          />
        </div>
      </div>
    </div>
  );
}
